module.exports = __webpack_public_path__ + "img/5.517ef89c.jpg";